import { MobilePopupWrapper, PCPopupWrapper } from './style';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import React, { useEffect, useState } from 'react';
import { CheckBoxCustom } from 'components/CheckBox/style';
import { useNavigate } from 'react-router-dom';
import ROUTE_PATH from '../../../routes/config';
import dayjs from 'dayjs';
import { KEY_FO_POPUP_EXPIRED_DATE } from '../../../tools/WebTool';

const moveToTargetPage = (popupData, navigate) => {
  const { serviceCenter } = ROUTE_PATH;
  // targetSeq가 0이면 목록, 아니면 상세
  if (popupData?.targetSeq === 0) {
    navigate(`${serviceCenter.noticeListPage}`, { state: { key: 'notice' } });
    return;
  }
  if (popupData?.targetSeq > 0) {
    window.open(
      `${serviceCenter.noticeListPage}/${popupData.targetSeq}`,
      '_blank'
    );
  }
};

const savePopupExpiredDate = () => {
  const expiredDate = dayjs().add(1, 'day').format('YYYY-MM-DD');
  localStorage.setItem(KEY_FO_POPUP_EXPIRED_DATE, expiredDate);
};

export const MobilePopup = ({ popupData, setPopupData }) => {
  const navigate = useNavigate();
  useEffect(() => {
    document.body.style.overflow = popupData ? 'hidden' : 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [popupData]);

  return (
    <MobilePopupWrapper>
      <div className="container">
        {popupData?.imageFilePath && (
          <img
            src={popupData?.imageFilePath}
            alt="팝업 공지 이미지"
            onClick={() => moveToTargetPage(popupData, navigate)}
          />
        )}
        <p
          className="title"
          onClick={() => moveToTargetPage(popupData, navigate)}
        >
          {popupData?.subject}
        </p>
        <div className="btnGroupWrapper">
          <button
            type="button"
            onClick={() => {
              savePopupExpiredDate();
              setPopupData(null);
            }}
          >
            오늘 하루 보지 않기
          </button>
          <button type="button" onClick={() => setPopupData(null)}>
            닫기
          </button>
        </div>
      </div>
    </MobilePopupWrapper>
  );
};

export const PCPopup = ({ popupData, setPopupData }) => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const handleCheck = e => {
    setIsChecked(prevState => !prevState);
  };

  const onClosePopup = () => {
    if (isChecked) {
      savePopupExpiredDate();
    }
    setPopupData(null);
  };
  return (
    <PCPopupWrapper>
      <div className="container">
        {popupData?.imageFilePath && (
          <img src={popupData?.imageFilePath} alt="팝업 공지 이미지" />
        )}

        <p className="title">{popupData?.subject}</p>
        <p className="content">{popupData?.contents}</p>
        <CheckBoxCustom className="checkBox">
          <input type="checkbox" onChange={e => handleCheck(e, setPopupData)} />
          <FeatherIcon
            icon="check"
            size={14}
            stroke="white"
            className="checkIcon"
          />
          <span>오늘 하루 보지않기</span>
        </CheckBoxCustom>
      </div>

      <div className="btnGroupWrapper">
        <button type="button" onClick={onClosePopup}>
          닫기
        </button>
        <button
          type="button"
          onClick={() => moveToTargetPage(popupData, navigate)}
        >
          자세히보기
        </button>
      </div>
      <button
        type="button"
        className="btnClose"
        onClick={() => setPopupData(null)}
      >
        <FeatherIcon icon="x" size={24} strokeWidth={2.2} />
      </button>
    </PCPopupWrapper>
  );
};
